import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21d6e4bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=21d6e4bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6e4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d6e4bc')) {
      api.createRecord('21d6e4bc', component.options)
    } else {
      api.reload('21d6e4bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21d6e4bc&scoped=true", function () {
      api.rerender('21d6e4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/bet-zone/index.vue"
export default component.exports